window.jQuery = $;
window.$ = $;

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk"
window.SpeechSDK = SpeechSDK
import "./plugin/bootstrap.bundle"
import $ from 'jquery'
import "./plugin/password.js"
import "./plugin/popup_translate"
import { CopyButtonPlugin } from "./copy"
import { Tooltip } from 'bootstrap'
window.CopyButtonPlugin = CopyButtonPlugin
window.Tooltip = Tooltip
require("bootstrap")
require("@popperjs/core")
Rails.start()
Turbolinks.start()
ActiveStorage.start()



document.addEventListener("turbolinks:load", () => {
  // Tooltip init
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
  });

  setTimeout(function() {
    $('.success, .alert').not('.alert-danger').fadeOut();
  }, 20000);
});
